import { useQuery } from '@tanstack/react-query';
import { useServicesContext } from '../../contexts/ServicesContext';

export const GetTeamLeadersKey = 'GET_TEAM_LEADERS';

export const useGetTeamLeaders = (teamId: number) => {
  const { fetchTeamLeaders } = useServicesContext();

  return useQuery({
    queryKey: [GetTeamLeadersKey],
    queryFn: () => fetchTeamLeaders(teamId),
  });
};
